import { render, staticRenderFns } from "./contract-panel.vue?vue&type=template&id=1920317a&"
import script from "./contract-panel.vue?vue&type=script&lang=js&"
export * from "./contract-panel.vue?vue&type=script&lang=js&"
import style0 from "./contract-panel.vue?vue&type=style&index=0&id=1920317a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports